

































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseEditor from '@/components/Editor.vue';
import { Form, FormRequest, FormLabel } from '@/models/Form';
import { mapGetters } from 'vuex';
import { User } from '@/models/User';
import { BAlert, BButton, BModal } from 'bootstrap-vue';
import { required } from 'vuelidate/lib/validators';

@Component({
    name: 'ModalFormConfig',
    components: {
        'b-button': BButton,
        'b-alert': BAlert,
        'base-editor': BaseEditor,
        'b-modal': BModal,
    },
    computed: mapGetters({
        formLabels: 'formLabels/all',
        users: 'users/all',
        account: 'account/account',
    }),
})
export default class ModalFormConfig extends Vue {
    @Prop() form!: Form;

    error: string = '';
    updating: boolean = false;

    // data
    id: number | null = null;
    formLabel: number | null = null;
    title: string = '';
    ownerUri: string = '';
    published: boolean = false;
    description: string = '';
    background: string = '#007bff';
    buttons: string = '#ffc107';
    gaTrackingCode: string = '';
    image: string | null = null;
    imagePreview: string = '';
    allowOpenEntry: boolean = false;
    allowAnonymousEntries: boolean = false;
    preview: boolean = true;
    allowRestart: boolean = false;
    receiveReportByEmail: boolean = false;

    // getters
    formLabels!: FormLabel[];
    users!: User[];
    account!: User;

    get selectedFormLabel() {
        return this.formLabels.find((f: FormLabel) => f.id === this.formLabel);
    }

    validations() {
        return {
            title: {
                required,
            },
        };
    }

    async reset() {
        this.error = '';

        if (this.form) {
            this.ownerUri = this.form.owner ? this.form.owner.uri : this.account.uri;
            this.title = this.form.title || '';
            this.published = this.form.published || true;
            this.description = this.form.description || '';
            this.formLabel = this.form.formLabel || this.formLabel;
            this.background = this.form.background || this.background;
            this.buttons = this.form.buttons || this.buttons;
            this.gaTrackingCode = this.form.gaTrackingCode || '';
            this.allowOpenEntry = this.form.allowOpenEntry || false;
            this.allowAnonymousEntries = this.form.allowAnonymousEntries || false;
            this.receiveReportByEmail = this.form.receiveReportByEmail || false;
            this.preview = this.form.preview || false;
            this.allowRestart = this.form.allowRestart || false;

            if (this.form.image) {
                try {
                    this.imagePreview = await this.$store.dispatch('forms/getImage', this.form.image);
                } catch (e) {
                    this.error = e;
                }
            }
        }

        this.$v.$reset();
    }

    onFileRemove() {
        this.image = null;
        this.form.image = null;
        this.imagePreview = '';
    }

    onFileUpload() {
        const reader = new FileReader();
        const fileInput = this.$refs.imageFile as any;

        reader.onload = (e: any) => {
            this.imagePreview = e.target.result;
        };
        reader.readAsDataURL(fileInput.files[0]);

        this.image = fileInput.files[0];
    }

    async submit() {
        const imageFile = new FormData();

        this.$v.$touch();

        if (this.$v.$invalid) {
            return;
        }

        this.updating = true;

        if (this.image) {
            imageFile.append('file', this.image);

            try {
                const r = await this.$store.dispatch('forms/uploadImage', imageFile);

                await this.save(r.data['@id']);
            } catch (e) {
                this.error = e;
                this.updating = false;
            }
        } else {
            this.save(null);
        }
    }

    async save(image: string | null) {
        try {
            const formData: FormRequest = {
                id: this.form ? this.form.id : null,
                title: this.title,
                published: this.published,
                description: this.description,
                image: image || (this.form && this.form.image) || null,
                formLabel: this.formLabel ? `/api/form_labels/${this.formLabel}` : null,
                background: this.background,
                buttons: this.buttons,
                gaTrackingCode: this.gaTrackingCode,
                allowOpenEntry: this.allowOpenEntry,
                allowAnonymousEntries: this.allowAnonymousEntries,
                allowRestart: this.allowRestart,
                receiveReportByEmail: this.receiveReportByEmail,
                preview: this.preview,
                owner: this.ownerUri ? this.ownerUri : this.account.uri,
            };
            const owner: any = this.users.find((u: User) => u.uri === formData.owner);

            await this.$store.dispatch(this.form ? 'forms/update' : 'forms/create', { owner, formData });

            this.$bvModal.hide(`modalFormConfig-${this.form ? this.form.id : ''}`);
        } catch (e) {
            this.error = e;
        } finally {
            this.updating = false;
        }
    }
}
